import { render } from "./DropdownMenu.vue?vue&type=template&id=8568652a&scoped=true"
import script from "./DropdownMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownMenu.vue?vue&type=script&setup=true&lang=js"

import "./DropdownMenu.vue?vue&type=style&index=0&id=8568652a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8568652a"],['__file',"src/components/UI/DropdownMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8568652a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8568652a', __exports__)) {
    api.reload('8568652a', __exports__)
  }
  
  module.hot.accept("./DropdownMenu.vue?vue&type=template&id=8568652a&scoped=true", () => {
    api.rerender('8568652a', render)
  })

}


export default __exports__